


















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import wtVideo from "@/components/custom/wtVideo/index.vue";
import wtImage from "@/components/custom/wtImage/index.vue";

const common = namespace("common");
const other = namespace("other");
@Component({
  components: {
    wtVideo,
    wtImage
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtTaskDetail extends Vue {
  @common.Action queryDataDictionaryListLang;
  @other.Action getInspectionsTasksDomain;
  @other.Action getStoreAnswerPaper;

  private dataList = [];

  private pageData = null;
  private loading = false;
  private onImageIndex = "";

  private dicStatusOptions = [];

  get routerCode() {
    return (this.$route.query.code || "") as any;
  }

  get imgSrcList() {
    const strs =
      "https://static.gtech.asia/dev/100008/20201119/1oJjtLleuT.jpg,https://static.gtech.asia/dev/100008/20201119/69Rc410GmW.jpg,https://static.gtech.asia/dev/100008/20201119/nbNn1Q7F0Q.jpg,https://static.gtech.asia/dev/100008/20201119/6QhRdM3Vnk.jpg";
    return strs;
  }
  get videoSrcList() {
    const strs =
      "https://static.gtech.asia/dev/100008/20201119/95p1OO2W79.mp4,https://static.gtech.asia/dev/100008/20201119/QF3QN89T81.mp4";
    return strs;
  }

  get dataListComputed() {
    return this.dataList;
  }

  get totalScore() {
    return this.dataList.reduce((a, c) => {
      return a + ((c && c.reviewTrialScore) || 0);
    }, 0);
  }

  async mounted() {
    this.initData();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };

    const timeArr = (time, index) => {
      return time && time.length > 0 ? time[index] : "";
    };

    try {
      let attachInput = {
        storeAnswerPaperCode: this.routerCode
      };
      if (status) {
        attachInput["state"] = parseInt(status);
      }
      let res = await this.getStoreAnswerPaper(attachInput);
      this.pageData = res;
      this.dataList = res && res.storeAnswerPaperInfoDomains;
      this.dataList.forEach(item => {
        this.$set(item, "isShowMedia", false);
        this.$set(item, "isShowVideo", false);
      });
    } catch (err) {
      this.pageData = null;
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }
  async initData() {
    this.loading = true;
    if (!this.routerCode) {
      this.dataList = [];
      this.$message.warning("请输入正确的链接");
      this.loading = false;
      return;
    }
    this.dicStatusOptions = await this.getProgressStatus(); // header info 需要状态
    // getData在前
    await this.getData();
    this.loading = false;
  }
  fPageData(prop) {
    const data = this.pageData;
    try {
      return (data && data[prop]) || "-";
    } catch (error) {
      return "-";
    }
  }

  fLink(info) {
    if (!info) return [];
    const infos = info.split(",");
    return infos;
  }

  get fTaskStatus() {
    const status = this.pageData && this.pageData.state;
    const obj = this.dicStatusOptions.find(
      item => item && parseInt(item.value) === parseInt(status)
    );
    return obj && obj.label;
  }

  async getProgressStatus() {
    const dicData = await this.queryDataDictionaryListLang({
      statePath: "wtTaskProgressList",
      ddCode: "INSPECTION_STATE"
    });
    const res = dicData.map(({ value, ...el }) => ({
      value: String(value),
      ...el
    }));
    return res;
  }

  async onImageLoad(imageIndex, isLoading) {
    if (!isLoading && this.onImageIndex === imageIndex) {
      try {
        const refPreviewer = this.$refs[`mediaPreviewer${imageIndex}`];
        this.$nextTick(() => {
          (refPreviewer && (refPreviewer[0] as any)).clickHandler();
        });
      } catch (error) {
        console.error("media-preview-error");
      }
    }
  }

  async handleShowMedia(row, imageIndex) {
    this.onImageIndex = imageIndex;
    row.isShowMedia = !row.isShowMedia;
  }
}
